module.exports = __webpack_public_path__ + "img/tile_seven.4c5e7386.png";